import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { bsClass, getClassSet, prefix, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
class Glyphicon extends React.Component {
  render() {
    const {
      glyph,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = {
      ...getClassSet(bsProps),
      [prefix(bsProps, glyph)]: true
    };
    return /*#__PURE__*/React.createElement("span", Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }));
  }
}
export default /* #__PURE__*/bsClass('glyphicon', Glyphicon);